import { makeStyles, Typography } from '@material-ui/core'
import styled from 'styled-components'
import { defaultTheme } from 'themes/DefaultTheme'
import MttButton from '../Material/MttButton/MttButton'

export const Container = styled.div`
  position: absolute;
  left: calc(50% + 4rem);
  bottom: 10%;
  transform: translateX(-50%);
  border-radius: 10px;

  z-index: 10;
  background-color: #e0e0e0;
  box-shadow: 1px 1px 3px 1px #00001150;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  max-width: 500px;
  width: 100%;
`

export const ContentContainer = styled.div`
  width: 100%;
  max-width: 350px;
  max-height: 67px;
`

export const TextContainer = styled(Typography).attrs({})`
  display: flex;
  max-width: 355px;
  font-size: 0.9rem !important;
`

export const ModalTitle = styled(Typography).attrs({
  variant: 'h6',
})``

export const ButtonContainer = styled.div``

export const ButtonOk = styled(MttButton)`
  width: 134px;
  height: 35px;
`

export const useStyles = makeStyles({
  modalTitle: {
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: 1.6,
    color: defaultTheme.palette.primary.main,
  },
  buttonOk: {
    fontSize: '0.8rem',
  },
})
